import makeStyles from '@mui/styles/makeStyles';
import { BlockItemFormat } from './';

export const BLOCK_ITEM_MARGIN = 16;
export const BLOCK_ITEM_HEIGHT = 140;

export const useStyles = makeStyles((theme) => ({
  cardActions: {
    width: '100%',
    justifyContent: 'flex-end',
  },
  content: ({ blockItemFormat }: { blockItemFormat: BlockItemFormat }) => ({
    position: 'relative',

    ...(blockItemFormat === BlockItemFormat.CONDENSED && {
      alignItems: 'stretch',
      display: 'flex',
      flexDirection: 'column',
      height: BLOCK_ITEM_HEIGHT,
      width: '75%',
    }),

    ...(blockItemFormat !== BlockItemFormat.CONDENSED && {
      transition: 'background-color 0.25s ease-out',

      '&:hover': {
        backgroundColor: 'rgb(253, 229, 178)',
      },
    }),

    '&:last-child': {
      padding: theme.spacing(2, 3),
    },
  }),
  site: {
    bottom: 40,
    color: '#d32f2f',
    fontWeight: 500,
    position: 'absolute',
    right: 20,
  },
  wrapper: {
    borderTop: `solid ${BLOCK_ITEM_MARGIN}px transparent`,
  },
  innerWrapper: ({
    blockItemFormat,
  }: {
    blockItemFormat: BlockItemFormat;
  }) => ({
    position: 'relative',

    ...(blockItemFormat === BlockItemFormat.CONDENSED && {
      display: 'flex',
      flexDirection: 'row',
    }),
  }),
}));
